import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {i18nMixin} from '@aofl/i18n-mixin';
import {sdoNs} from '@modules/constants-enumerate';
import translations from '@modules/i18n';

const setTranslations = (ctx) => {
  return {
    selections: [
      {
        label: ctx.__('<tt-IleSWtIs>', 'Select Class Assignment'),
        value: ''
      },
      {
        label: ctx.__('<tt-VHvOsN4Y>', 'Assigned to a Class'),
        value: 'assigned'
      },
      {
        label: ctx.__('<tt-fS9D1xV9>', 'NOT assigned to a Class'),
        value: 'not_assigned'
      }
    ]
  };
};

/**
 * @summary UserSearchClassAssignmentFilters
 * @extends {AoflElement}
 */
@customElement('user-search-class-assignment-filters')
class UserSearchClassAssignmentFilters extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of UserSearchClassAssignmentFilters.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'user-search-class-assignment-filters';

  @property({type: Array})
  selections = [];

  @property({type: Number})
  currentClassAssignmentSelectionLabel = '';
  selectOption(index) {
    this.currentClassAssignmentSelectionLabel = this.selections[index].label;

    this.storeInstance.commit(
      {
        namespace: sdoNs.USER_SEARCH,
        mutationId: 'setClassAssignment',
        payload: this.selections[index].value
      }
    );

    this.dispatchEvent(new CustomEvent('changed', {
      composed: true,
      bubbles: true
    }));
  }

  async connectedCallback() {
    super.connectedCallback();
    const state = this.storeInstance.getState();

    const t10s = setTranslations(this);
    for (const index in t10s) {
      this[index] = t10s[index];
    }

    this.currentClassAssignmentSelectionLabel = this.selections[0].label;

    if (state[sdoNs.USER_SEARCH].pendingFilters.class_assigned) {
      const labelIndex = this.selections.findIndex((element) => {
        return element.value === state[sdoNs.USER_SEARCH].pendingFilters.class_assigned;
      });
      this.currentClassAssignmentSelectionLabel = this.selections[labelIndex].label;
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export {
  UserSearchClassAssignmentFilters
};

